import { ProtectorType } from 'core/constants';

export type EventFieldKind = 'option' | 'text' | 'date';

export interface EventFieldEntry {
  key: string;
  name: string;
  kind: EventFieldKind;
}

const FIELD_KIND: Record<ProtectorType, EventFieldKind> = {
  [ProtectorType.ShortText]: 'text',
  [ProtectorType.LongText]: 'text',
  [ProtectorType.SingleChoice]: 'option',
  [ProtectorType.MultiChoice]: 'option',
  [ProtectorType.Date]: 'date',
  [ProtectorType.User]: 'option',
  [ProtectorType.Location]: 'text',
  [ProtectorType.Number]: 'text',
  [ProtectorType.DateTime]: 'date',
  [ProtectorType.Time]: 'date',
  [ProtectorType.Lookup]: 'option',
  [ProtectorType.RiskFactor]: 'text',
  [ProtectorType.Pipeline]: 'option',
  [ProtectorType.Stage]: 'option',
  [ProtectorType.Image]: 'text',
  [ProtectorType.Section]: 'text',
  [ProtectorType.Attachment]: 'text',
  [ProtectorType.Signature]: 'text',
  [ProtectorType.RepeatingGroup]: 'text',
  [ProtectorType.YesNoNa]: 'text',
};

export const eventFieldKind = (protectorType: ProtectorType): EventFieldKind => FIELD_KIND[protectorType];

export const COMPARABLE_SUBFIELD: Partial<Record<ProtectorType, string>> = {
  [ProtectorType.Location]: 'address',
  [ProtectorType.RiskFactor]: 'score',
};

export const IDENTITY_TYPES: ReadonlySet<ProtectorType> = new Set([
  ProtectorType.Lookup,
  ProtectorType.User,
  ProtectorType.Stage,
  ProtectorType.Pipeline,
]);

export const CHOICE_TYPES: ReadonlySet<ProtectorType> = new Set([
  ProtectorType.SingleChoice,
  ProtectorType.MultiChoice,
]);
